/** Extracts a displayable message from an unknown thrown value -- `apiFetch`/`apiFetchOptional`
 * always throw a real `Error` (e.g. "API error: 502 Bad Gateway"), but this stays defensive
 * against anything else ending up in a query's `error`. */
export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}
